import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import LoadingSpinner from '../partials/LoadingSpinner';

import { Text, Button, Checkbox, H4, Input, Badge, Tooltip } from '@bigcommerce/big-design';
import { EditIcon, DeleteIcon, VisibilityIcon, CheckIcon } from '@bigcommerce/big-design-icons';

import { purchaseOrderAddItem } from '../../redux/actions/purchaseOrders';
import { getAssignmentLocationThresholds } from '../../redux/actions/assignments';

const ItemLine = ({ 
  payload,
  activeShippingAddress,
  products,
  hasVariants, 
  productId, 
  itemId, 
  imageUrl, 
  fullImageUrl,
  inventoryTracking, 
  options, 
  name,
  binPickingNumber,
  sku,
  upc,
  type,
  rowId,
  quantity,
  price,
  assignments,
  thresholds,
  getRelatedThresholds,
  assignment,
  addItem,
  bigcommerceSettings,
  setModalProductId,
  setModalVariantId,
  setModalOptions,
  setModalProductName,
  setModalType,
  setModalAssignment,
  setShowAddSupplierAssignmentModal,
  setShowUpdateSupplierAssignmentModal,
  setShowDeleteSupplierAssignmentModal,
  setShowOtherSuppliersModal,
  activeSupplier,
  purchaseOrderLines,
  showInventoryModal,
  settings }) => {

  const [assignmentQuantities, setAssignmentQuantities] = useState({});

  useEffect(() => {
    if(activeShippingAddress?.address) {
      if(type === 'variant') {
        // Do not search if currently searching
        if(thresholds.searchingAssignmentLocationThresholds.findIndex((key) => key === `${activeShippingAddress.id}/${productId}/${itemId}`)  >= 0) { return; };

        // Do not search if the value is already there
        if(Object.keys(thresholds.assignmentLocationThresholds).findIndex((key) => key === `${activeShippingAddress.id}/${productId}/${itemId}`)  >= 0) { return; };

        // Search if the key doesn't exist
        getRelatedThresholds(payload, activeShippingAddress.id, productId, itemId);
      } else {
        // Do not search if currently searching
        if(thresholds.searchingAssignmentLocationThresholds.findIndex((key) => key === `${activeShippingAddress.id}/${productId}/null`)  >= 0) { return; };

        // Do not search if the value is already there
        if(Object.keys(thresholds.assignmentLocationThresholds).findIndex((key) => key === `${activeShippingAddress.id}/${productId}/null`)  >= 0) { return; };

        // Search if the key doesn't exist
        getRelatedThresholds(payload, activeShippingAddress.id, productId, null);
      }

    }
  }, [activeShippingAddress]);


  const format = (value) => {
    let formattedValue = "";

    if(bigcommerceSettings.currency_symbol_location === 'left') {
      formattedValue += bigcommerceSettings.currency_symbol
    }
    
    formattedValue += parseFloat(value).toFixed(bigcommerceSettings.decimal_places)

    if(bigcommerceSettings.currency_symbol_location !== 'left') {
      formattedValue += bigcommerceSettings.currency_symbol
    }

    formattedValue = formattedValue.replace('.', bigcommerceSettings.decimal_separator)

    return formattedValue;
  }

  const showOtherSuppliersModal = () => {
    setModalProductId(productId);
    
    if(type === 'variant') {
      setModalVariantId(itemId);
    } else {
      setModalVariantId(null);
    }

    setModalOptions(options);
    setModalProductName(name);
    setModalType(type);

    setShowOtherSuppliersModal(true);
  }

  const showAddSupplierAssignmentModal = () => {
    setModalProductId(productId);
    
    if(type === 'variant') {
      setModalVariantId(itemId);
    } else {
      setModalVariantId(null);
    }

    setModalOptions(options);
    setModalProductName(name);
    setModalType(type);

    setShowAddSupplierAssignmentModal(true);
  }

  const showUpdateSupplierAssignmentModal = () => {
    setModalProductId(productId);
    
    if(type === 'variant') {
      setModalVariantId(itemId);
    } else {
      setModalVariantId(null);
    }

    setModalOptions(options);
    setModalProductName(name);
    setModalType(type);
    setModalAssignment(JSON.parse(assignment?.value));

    setShowUpdateSupplierAssignmentModal(true);
  }

  const showDeleteSupplierAssignmentModal = () => {
    setModalProductId(productId);

    if(type === 'variant') {
      setModalVariantId(itemId);
    } else {
      setModalVariantId(null);
    }

    setModalOptions(options);
    setModalProductName(name);
    setModalType(type);
    setModalAssignment(JSON.parse(assignment?.value));

    setShowDeleteSupplierAssignmentModal(true);
  }

  const showOtherSuppliersButton = () => {
    let fieldKey = '';

    if(type === 'variant') {
      fieldKey = `${productId}/${itemId}`;
    } else {
      fieldKey = `${productId}/${null}`;
    }

    if(products?.searchedVariantsMetafields && products?.searchedVariantsMetafields[fieldKey]) {
      return (products?.searchedVariantsMetafields[fieldKey]?.data.filter(assignment => assignment.key !== `Supplier-${activeSupplier?.id}`).length > 0)
    }

    return false;
  }

  const handleAdd = (assignment) => {
    let itemData = {};

    if(type === 'variant') {
      itemData.productId = productId;
      itemData.variantId = itemId;
    } else {
      itemData.productId = productId;
      itemData.variantId = null;
    }

    itemData.productName = name;
    itemData.imageUrl = imageUrl;
    itemData.fullImageUrl = fullImageUrl;
    itemData.options = options;
    itemData.sku = sku;
    itemData.upc = upc;
    itemData.supplier_sku = JSON.parse(assignment?.value).supplier_sku;
    itemData.supplier_price = JSON.parse(assignment?.value).supplier_price;
    itemData.minimumOrder = JSON.parse(assignment?.value).minimum_order;
    
    if(settings?.settings?.order_multiples) {
      itemData.orderMultiple = JSON.parse(assignment?.value).order_multiple;
    }

    if(settings?.settings?.pack_quantities) {
      itemData.packQuantity = JSON.parse(assignment?.value).pack_quantity;
    }

    itemData.setQuantity = assignmentQuantities[`${productId}/${itemId || 'null'}`] || JSON.parse(assignment?.value).minimum_order;

    addItem(payload, itemData);
  }

  const updateAssignmentQuantityField = (event, key) => {
    let value = event.target.value;
    let newQuantities = { ...assignmentQuantities };

    newQuantities[key] = parseInt(value);
    setAssignmentQuantities(newQuantities);
  }

  return(
    <div className="has-hover sku-line flex-container">
      <div className={`flex-1 ${type === 'variant' && 'left-15'}`}>
        <div className="flex-container">
          <div className="left-15">
            { imageUrl && <img src={imageUrl} /> }
            { !imageUrl && <Text>No image</Text>}
          </div>
        </div>
      </div>

      <div className="flex-2">
        <div className="left-15">
          <H4>Assignment Details</H4>
          { (assignments.status === 'success') && assignment && <ul>
            <li>Supplier SKU: <Badge label={JSON.parse(assignment?.value).supplier_sku || "Not set"} variant={JSON.parse(assignment?.value).supplier_sku ? "success" : "warning"} /></li>
            <li>Supplier Price: <Badge label={JSON.parse(assignment?.value).supplier_price ? format(JSON.parse(assignment?.value).supplier_price) : "Not set"} variant={JSON.parse(assignment?.value).supplier_price ? "success" : "warning"} /></li>
            <li>Minimum Order Quantity: <Badge label={JSON.parse(assignment?.value).minimum_order || "Not set"} variant={JSON.parse(assignment?.value).minimum_order ? "success" : "warning"} /></li>
            { settings?.settings?.order_multiples && 
              <li>Order Multiple: <Badge label={JSON.parse(assignment?.value).order_multiple || "Not set"} variant={JSON.parse(assignment?.value).order_multiple ? "success" : "warning"} /></li>
            }
            { settings?.settings?.pack_quantities && 
              <li>Pack Quantity: <Badge label={JSON.parse(assignment?.value).pack_quantity || "Not set"} variant={JSON.parse(assignment?.value).pack_quantity ? "success" : "warning"} /></li>
            }
          </ul> }
          { (assignments.status === 'success') && !assignment &&
            <Badge label="No supplier assignment" variant="warning" />
          }
          { (assignments.status === 'success') && assignment &&
            <>
              <Button
                variant="utility"
                onClick={() => showUpdateSupplierAssignmentModal()}
                iconLeft={<EditIcon />}
              >
                Update supplier assignment
              </Button>

              <Button
                actionType="destructive"
                variant="utility"
                onClick={() => showDeleteSupplierAssignmentModal()}
                iconLeft={<DeleteIcon />}
              >
                Delete supplier assignment
              </Button>

            </>
          }

          { assignments.status !== 'success' &&
            <LoadingSpinner size="xxSmall" statusText="Loading assignments"/>
          }
        </div>
      </div>

      <div className="flex-2">
        <div className="flex-container">
          <H4>{name}</H4>
        </div>
        <ul>
          { options && options.map(option =>
              <li>
                <strong>{ option.option_display_name }</strong>: { option.label }
              </li>
            )
          }
          { !options &&
            <Text color="warning40">
              Base Product
            </Text>
          }

          <li>
            <Tooltip placement="top-start" trigger={<strong>Default location inventory</strong>}>
              Default location is likely the first location form your BigCommerce store. Check BigCommerce settings and inventory levels to verify your BigCommerce location.
            </Tooltip>
            : { quantity }
          </li>

          { activeShippingAddress?.address && thresholds.assignmentLocationThresholds[`${activeShippingAddress?.id}/${productId}/${itemId || 'null'}`] &&
            <li>
              <Text>
                <strong>Target Inventory</strong>: &nbsp;
                { thresholds.assignmentLocationThresholds[`${activeShippingAddress?.id}/${productId}/${itemId || 'null'}`]?.target_inventory }
              </Text>
            </li>
          }
        </ul>

        { inventoryTracking !== 'none' &&
          <Button
            variant="secondary"
            iconLeft={<VisibilityIcon />}
            onClick={() => showInventoryModal(inventoryTracking, productId, itemId)}
          >
            View Inventory Levels
          </Button>
        }

        { showOtherSuppliersButton() &&
          <Button
            variant="utility"
            iconLeft={<VisibilityIcon />}
            onClick={() => showOtherSuppliersModal()}
          >
            View Other Suppliers
          </Button>
        }
        
      </div>
      <div className="flex-1">
        { ((inventoryTracking === 'product' && type === 'product') || (inventoryTracking === 'none' && !hasVariants) || (type === 'variant')) &&
          <>
            { !(Object.keys(purchaseOrderLines.lineDetails).find( (key) => (key === `${productId}/${itemId}` || key === `${productId}/null`) )) &&
              <>
                { assignment &&
                  <div className="flex-container flex-end">
                    <Text marginTop="xxSmall" as="span">QTY: &nbsp;&nbsp;</Text>
                    <div className="width-50">
                      <Input
                        label=""
                        onChange={(e) => updateAssignmentQuantityField(e, `${productId}/${itemId || 'null'}`)}
                        placeholder="QTY"
                        type="number"
                        value={assignmentQuantities[`${productId}/${itemId || 'null'}`] || JSON.parse(assignment?.value).minimum_order || 1}
                        required
                      />
                    </div>
                  </div>
                }

                <Button
                  disabled={!assignment}
                  onClick={() => handleAdd(assignment)}
                  variant="secondary"
                >
                  Add to Purchase Order
                </Button>
              </>
            }
            { Object.keys(purchaseOrderLines.lineDetails).find( (key) => (key === `${productId}/${itemId}` || key === `${productId}/null`) ) &&
              <Button
                iconLeft={<CheckIcon />}
                disabled
                variant="secondary"
              >
                Added to Purchase Order
              </Button>
            }
            {!assignment &&
              <>
                <br/>
                <Button
                  variant="utility"
                  onClick={() => showAddSupplierAssignmentModal()}
                >
                  + Add supplier assignment
                </Button>
              </>
            }
          </>
        }

      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  bigcommerceSettings: state.stores.settings,
  assignments: state.assignments,
  products: state.products,
  purchaseOrderLines: state.purchaseOrderLines,
  thresholds: state.thresholds,
  settings: state.settings,
});

const mapDispatchToProps = (dispatch) => ({
  addItem: (payload, itemData) => dispatch(purchaseOrderAddItem(payload, itemData)),
  getRelatedThresholds: (payload, locationId, productId, variantId) => dispatch(getAssignmentLocationThresholds(payload, locationId, productId, variantId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ItemLine);
